import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import type { PaginationParams } from '@core/http-types';
import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { SignInConsent, SignInConsentResponse } from '@core/tellent-types';
import { APP_GUID } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class TellentGrantAccessHttpClient {
  private appGuid = inject(APP_GUID);
  constructor(protected httpApi: TellentHttpApiService) {}

  public fetchSignInCOnsetList(params: PaginationParams): Observable<SignInConsentResponse> {
    const { page, limit } = params;

    return this.httpApi
      .get('/sign-in-consent', {
        page,
        limit,
      })
      .pipe(map((response: SignInConsentResponse) => response));
  }

  public grantAccess(): Observable<SignInConsent> {
    return this.httpApi
      .post('/sign-in-consent/grant-access')
      .pipe(map((response: { data: SignInConsent }) => response.data));
  }

  public revokeAccess(): Observable<SignInConsent> {
    return this.httpApi
      .post('/sign-in-consent/revoke-access')
      .pipe(map((response: { data: SignInConsent }) => response.data));
  }
}
